import React from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import LogoutIcon from '@mui/icons-material/Logout';

const Navbar = () => {
    const { isAuthenticated, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    return (
        <AppBar position="static">
            <Toolbar>
                <Typography
                    variant="h6"
                    component={RouterLink}
                    to="/dashboard"
                    sx={{ textDecoration: 'none', color: 'inherit' }}
                >
                    xAPI LRS
                </Typography>

                <Box sx={{ flexGrow: 1 }} />

                {isAuthenticated && (
                    <Box>
                        <Button
                            component={RouterLink}
                            to="/dashboard"
                            color="inherit"
                        >
                            Dashboard
                        </Button>
                        <Button
                            component={RouterLink}
                            to="/source-systems"
                            color="inherit"
                        >
                            Quellsysteme
                        </Button>
                        <Button
                            component={RouterLink}
                            to="/database-browser"
                            color="inherit"
                        >
                            Daten durchsuchen
                        </Button>
                        <IconButton onClick={handleLogout} color="inherit">
                            <LogoutIcon />
                        </IconButton>
                    </Box>
                )}
            </Toolbar>
        </AppBar>
    );
};

export default Navbar;
